import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND, CATEGORIES } from "@/data/products";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#1A1A1A] text-[#E5E5E5] mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <img
            src={BRAND.logo}
            alt="Hospitality Hub"
            className="h-20 sm:h-24 md:h-[120px] w-auto object-contain object-left -ml-[34px] sm:-ml-[40px] md:-ml-[52px]"
          />
          <p className="mt-5 text-sm text-[#B5B5B5] leading-relaxed max-w-sm">
            Factory-direct hospitality supplies for hotels across the United States.
            Where luxury meets affordability, since 2023.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-serif-display text-lg text-white mb-4">Categories</h4>
          <ul className="space-y-2 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/products/${c.slug}`}
                  data-testid={`footer-cat-${c.slug}`}
                  className="text-[#B5B5B5] hover:text-[#D4AF37] transition-colors"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-serif-display text-lg text-white mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" data-testid="footer-link-home" className="text-[#B5B5B5] hover:text-[#D4AF37]">Home</Link></li>
            <li><Link to="/about" data-testid="footer-link-about" className="text-[#B5B5B5] hover:text-[#D4AF37]">About</Link></li>
            <li><Link to="/contact" data-testid="footer-link-contact" className="text-[#B5B5B5] hover:text-[#D4AF37]">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-serif-display text-lg text-white mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 text-[#D4AF37] mt-0.5" />
              <a href={`tel:${BRAND.phone}`} data-testid="footer-phone" className="text-[#B5B5B5] hover:text-[#D4AF37]">{BRAND.phone}</a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 text-[#D4AF37] mt-0.5" />
              <a href={`mailto:${BRAND.email}`} data-testid="footer-email" className="text-[#B5B5B5] hover:text-[#D4AF37] break-all">{BRAND.email}</a>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 text-[#D4AF37] mt-0.5" />
              <span className="text-[#B5B5B5]">Serving hotels across the United States</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-xs text-[#8A8A8A] uppercase tracking-[0.2em]">© {new Date().getFullYear()} Hospitality Hub · All rights reserved</p>
          <p className="text-xs text-[#8A8A8A] uppercase tracking-[0.2em]">Where Luxury Meets Affordability</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
